<template>
  <div class="line-item-v2">
    <div class="d-flex mb-2 align-center justify-space-between">
      <div class="d-flex">
        <v-btn-toggle color="cyan" group>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="product"
            v-on:click="open_dialog('product', 'top')"
          >
            Product
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div class="custom-grey-border">
      <div class="d-flex grey lighten-4">
        <div
          class="color-custom-blue py-2 font-weight-700 text-center"
          style="width: 2%"
        >
          #
        </div>
        <div
          class="color-custom-blue py-2 font-weight-700 text-left"
          style="width: 57%"
        >
          Product
        </div>
        <div
          class="color-custom-blue py-2 font-weight-700 px-2"
          style="width: 10%"
        >
          Available Qty.
        </div>

        <div
          class="color-custom-blue py-2 font-weight-700 px-2"
          style="width: 10%"
        >
          Type
        </div>
        <div
          class="color-custom-blue py-2 font-weight-700 px-2"
          style="width: 10%"
        >
          Adjusted Qty.
        </div>
        <div
          class="color-custom-blue py-2 font-weight-700 px-2"
          style="width: 8%"
        >
          Updated Qty.
        </div>

        <div
          class="color-custom-blue py-2 font-weight-700 px-2"
          style="width: 3%"
        ></div>
      </div>
      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag"
            :key="`line-item-drag-${index}`"
          >
            <div :id="`line-item-drag-${index}`" class="d-flex my-0">
              <div
                class="font-weight-600 text-center"
                style="width: 2%; margin-left: -5px"
              >
                {{ index + 1 }}
              </div>
              <div class="text-left px-2" style="width: 57%">
                <div class="d-flex">
                  <v-avatar size="32">
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-text-field
                      readonly
                      v-model.trim="row.product"
                      class="line-item-header-text px-0"
                      placeholder="Line Item"
                      dense
                      filled
                      solo
                      v-on:change="changeName(index, row.product)"
                      flat
                      color="cyan"
                    >
                      <template v-slot:append>
                        <v-chip
                          :key="`product-isSerialized-${row?.index}-${index}-${row?.product_id}`"
                          :color="row?.isSerialized ? 'green' : 'red'"
                          style="max-width: 90px !important"
                          class="ml-2"
                          small
                          label
                          text-color="white"
                        >
                          {{
                            row?.isSerialized ? "Serialized" : "Non-serialized"
                          }}
                        </v-chip>
                        <v-tooltip
                          top
                          content-class="custom-top-tooltip"
                          :key="`product-serial_numbers-${row?.index}-${index}-${row?.product_id}`"
                          v-if="row?.isSerialized > 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              color="blue darken-4 white--text"
                              label
                              small
                              style="width: 28px; margin-left: 5px"
                              v-on:click="
                                update_serial_numbers_dialog(
                                  row,
                                  index,
                                  row.serial_numbers
                                )
                              "
                              class="text-uppercase font-weight-600"
                            >
                              <v-icon small>mdi-cog</v-icon>
                            </v-chip>
                          </template>
                          <span>Manage Serial Numbers</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </div>
                <div>
                  <v-chip
                    v-if="row?.barcode"
                    label
                    color="chip-custom-blue"
                    outlined
                    small
                    class="text-white px-1 mt-1"
                    style="font-weight: 700"
                    >{{ row.barcode }}</v-chip
                  >
                </div>
              </div>
              <div class="text-left px-2" style="width: 10%">
                <v-text-field
                  class="line-item-header-text px-0 d-none"
                  placeholder="Available Qty."
                  dense
                  filled
                  solo
                  type="number"
                  readonly
                  v-model="row.initial_stock"
                  flat
                  color="cyan"
                  v-on:keypress="isNumber($event, row.initial_stock)"
                />
                <span class="font-weight-700 font-size-17 ml-2">{{
                  row.initial_stock
                }}</span>
              </div>
              <div class="text-center px-2" style="width: 10%">
                <v-autocomplete
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="calculation_type"
                  placeholder="Type"
                  solo
                  flat
                  item-text="text"
                  item-value="id"
                  return-object
                  :class="`pr-0 width-33 ${
                    row?.calculation_type ? '' : 'error--text'
                  }`"
                  :style="
                    row?.calculation_type
                      ? row.calculation_type.id == 1
                        ? 'background-color: rgb(248, 201, 201) !important;'
                        : 'background-color: rgb(220, 246, 220) !important;'
                      : ''
                  "
                  v-model.trim="row.calculation_type"
                  @change="
                    adjustedquantitycalculation(row, index, 'calculation_type')
                  "
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Type Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div class="text-center px-2" style="width: 10%">
                <v-text-field
                  :readonly="row.calculation_type ? false : true"
                  :class="`px-0 ${
                    row?.adjusted_quantity > 0 ? '' : 'error--text'
                  }`"
                  placeholder="Adjusted Qty."
                  dense
                  filled
                  solo
                  flat
                  type="number"
                  v-model="row.adjusted_quantity"
                  v-on:keydown="blockKeys($event, row.adjusted_quantity)"
                  @paste="blockNegativePaste($event)"
                  v-on:keypress="isNumber($event)"
                  color="cyan"
                  @input="adjustedquantitycalculation(row, index)"
                >
                  <template #prepend-inner>
                    <v-icon :color="getIconColor(row)">
                      {{ getIconName(row) }}
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="text-left px-2" style="width: 8%">
                <v-text-field
                  class="line-item-header-text px-0 d-none"
                  placeholder="Updated Qty."
                  dense
                  filled
                  solo
                  flat
                  type="number"
                  v-model="row.total_qty"
                  v-on:keypress="isNumber($event)"
                  color="cyan"
                  readonly
                />
                <span class="font-weight-700 font-size-17 ml-2">{{
                  row.total_qty
                }}</span>
              </div>
              <div class="font-weight-600 text-right" style="width: 3%">
                <v-btn
                  v-on:click="remove_row(index, row)"
                  icon
                  color="red lighten-1"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="custom-border-top p-3">
          <p
            class="m-0 p-4 font-size-16 font-weight-500 light-gray-background custom-grey-border d-flex align-center"
          >
            <v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
            Oops... Nothing Found.
          </p>
        </div>
      </template>
    </div>

    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :product-dialog="product_dialog"
      v-on:update-values="update_line_item($event)"
      v-on:close="(product_dialog = false), (module_type = null)"
    />
    <Dialog :common-dialog="adjustedquantitydialog">
      <template v-slot:title> Confirmation </template>
      <template v-slot:body>
        <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
          <v-container class="px-10" fluid>
            <p class="font-weight-600 font-size-19">
              Product QTY. will become negative. Are you sure you want proceed ?
            </p>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          v-on:click="quantityDialog(false)"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          No! Close
        </v-btn>
        <v-btn
          v-on:click="quantityDialog(true)"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
        >
          Yes! Continue
        </v-btn>
      </template>
    </Dialog>
    <SerialNumber
      v-if="serial_number_dialog"
      :key="`product-new-serial-number-dialog-${dialog_key}`"
      :dialogStatus="serial_number_dialog"
      :serial-array="serial_number_array"
      :serial-object="serial_number_object"
      v-on:close:dialog="close_serial_number_dialog()"
      v-on:save="saveData($event)"
    >
    </SerialNumber>

    <!-- Upload Image :: end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import LineItemDialog from "@/view/pages/product/adjustment/AdjustmentItemDialog.vue";
import SerialNumber from "@/view/components/Serial-Number-Dialog.vue";
import { SET_LINE_ITEM } from "@/core/services/store/line.item.module";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { /* ErrorEventBus, */ ClearEventBus } from "@/core/lib/message.lib";
import { cloneDeep } from "lodash";
import ObjectPath from "object-path";
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  name: "line-item-v1",
  mixins: [CommonMixin],
  data() {
    return {
      calculation_type: [
        {
          id: 1,
          text: "Subtraction",
        },
        {
          id: 2,
          text: "Addition",
        },
      ],
      product_location: null,
      drag: false,
      module_type: null,
      numberIndex: -1,
      dialog_key: Number(new Date()),
      product_type: null,
      product_dialog: false,
      selected_line_items: [],
      adjusted_quantity_index: null,
      adjustedquantitydialog: false,
      serial_number_dialog: false,
      serial_number_object: {},
      serial_number_array: [],
    };
  },
  props: {},
  watch: {},
  methods: {
    update_serial_numbers_dialog(row, index) {
      this.serial_number_object = row;
      this.serial_number_array = row?.serial_numbers;
      this.numberIndex = index;
      this.serial_number_dialog = true;
    },
    getIconColor(row) {
      if (!row?.calculation_type) return "";
      return row.calculation_type.id == 1 ? "red" : "green";
    },
    getIconName(row) {
      if (!row?.calculation_type) return "";
      return row.calculation_type.id == 1 ? "mdi-minus" : "mdi-plus";
    },
    quantityDialog(status) {
      const index = this.adjusted_quantity_index;
      if (!status) {
        this.selected_line_items[index].adjusted_quantity = null;
        this.selected_line_items[index].total_qty = null;
        this.adjustedquantitydialog = false;
      } else {
        this.adjustedquantitydialog = false;
      }
      this.adjusted_quantity_index = null;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    adjustedquantitycalculation(item, index, calculation_type = null) {
      const available = Number(item.initial_stock) || 0;
      const adjusted = Number(item.adjusted_quantity) || 0;

      this.adjusted_quantity_index = index;

      // Must have type selected
      if (!item.calculation_type || !item.calculation_type.text) return;

      const type = item.calculation_type.text;
      if (item?.isSerialized > 0 && type === "Subtraction") {
        if (adjusted > available) {
          item.adjusted_quantity = null;
          item.total_qty = null; // reset
          this.$set(this.selected_line_items, index, { ...item });
          return;
        }
      }

      if (type === "Subtraction") {
        if (adjusted > available) {
          this.adjustedquantitydialog = true;
          item.total_qty = available - adjusted;
          return;
        }
        item.total_qty = available - adjusted;
      }

      if (type === "Addition") {
        item.total_qty = available + adjusted;
      }
      this.$set(this.selected_line_items, index, { ...item });
      this.$nextTick(() => {
        this.emit_values();
      });

      if (calculation_type && calculation_type == "calculation_type") {
        ObjectPath.set(
          this.selected_line_items,
          `${index}.adjust_serial_array`,
          []
        );
        this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      }
    },
    saveData(param) {
      const qty_array = cloneDeep(param);
      ObjectPath.set(
        this.selected_line_items,
        `${this.numberIndex}.adjust_serial_array`,
        qty_array
      );
      this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      this.close_serial_number_dialog();
    },
    close_serial_number_dialog() {
      this.serial_number_object = {};
      this.serial_number_array = [];
      this.numberIndex = -1;
      this.serial_number_dialog = false;
      this.$nextTick(() => {
        ClearEventBus.$emit("clear:error");
      });
    },

    update_line_item(param) {
      for (let item of param) {
        if (this.product_location == "top") {
          this.selected_line_items.unshift(item);
        } else {
          this.selected_line_items.push(item);
        }
      }
      this.$nextTick(() => {
        this.emit_values();
        this.product_dialog = false;
        this.product_type = null;
        this.product_location = null;
        this.module_type = null;
      });
    },

    changeName(index, row) {
      this.selected_line_items[index].product = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },

    emit_values() {
      this.$nextTick(() => {
        this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      });
    },

    open_dialog(param) {
      if (!param) {
        return false;
      }
      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
    },

    remove_row(index) {
      this.selected_line_items.splice(index, 1);
      this.emit_values();
    },
  },
  components: {
    Draggable,
    LineItemDialog,
    Dialog,
    SerialNumber,
  },
  mounted() {},

  created() {},
  computed: {
    ...mapGetters([]),
  },
};
</script>
